import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'form-search-dialog',
    templateUrl: './form-search-dialog.component.html',
    providers: [DataService]
})
export class FormSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'Form';
        this.model.title = 'Select Forms';

        this.model.criteria.Form_Num_Mode = 'Beginswith';
        this.model.criteria.Form_Name_Mode = 'Beginswith';

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
